import { forwardRef } from 'react'
import { StyledStars } from './styles'
import { ratingFromNumber, StarsProps } from './props'
import {
    Trustpilot0,
    Trustpilot1,
    Trustpilot15,
    Trustpilot2,
    Trustpilot25,
    Trustpilot3,
    Trustpilot35,
    Trustpilot4,
    Trustpilot45,
    Trustpilot5,
} from '../../Assets/Icons'

const stars = {
    0: Trustpilot0,
    1: Trustpilot1,
    1.5: Trustpilot15,
    2: Trustpilot2,
    2.5: Trustpilot25,
    3: Trustpilot3,
    3.5: Trustpilot35,
    4: Trustpilot4,
    4.5: Trustpilot45,
    5: Trustpilot5,
}

/**
 *
 * @param rating: number 1-5
 * @returns
 */
const Stars = forwardRef<HTMLImageElement, StarsProps>((props, ref) => (
    <StyledStars
        {...props}
        ref={ref}
        src={stars[ratingFromNumber(props.rating)]}
    />
))

Stars.displayName = 'Stars'

export default Stars

export { StyledStars }
